import { wow_doctor } from "../../js/path";

export default {
  data() {
    return {
      tableData: {
        doctors: [],
        total: 0,
        current_page: 1,
        last_page: 1,
        size: 20,
      },

      fields: [
        { key: "_id", sortable: true },
        { key: "fname", label: "Member Name" },
        { key: "token", label: "Tokens" },
        { key: "e_wallet", label: "Credits" },
        { key: "transaction", label: "Show Transaction" },
      ],

      currentPage: 1,
      filter: "",
      pageNo: null,
      editedRowId: null,
      editedCreditRowId: null,
      key: 0,
    };
  },

  methods: {
    enableTokenEdit(item) {
        this.editedRowId = item._id;
        this.existingTokens = item.token ?? 0;
        this.addTokens = 0;
    },
    enableCreditEdit(item) {
        this.editedCreditRowId = item._id;
        this.existingCredits = item.e_wallet ?? 0;
        this.addCredits = 0;
    },
    // ✅ MAIN API CALL
    async fetchData() {
      const url =
        wow_doctor.wowDoctorUrl +
        `?pagination=true&page=${this.currentPage}&size=20` +
        (this.filter ? `&search=${this.filter}` : "");

      this.updateUrl();

      this.$store.commit("loader/updateStatus", true);

      try {
        const res = await this.getRequest(url);

        if (res.status) {
          this.tableData = res.data;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Something went wrong",
        });
      }

      this.$store.commit("loader/updateStatus", false);
      this.key++;
    },

    // ✅ SEARCH BUTTON
    searchFor() {
      this.currentPage = 1;
      this.fetchData();
    },

    // ✅ ENTER SEARCH
    search(event) {
      if (event.keyCode === 13) {
        this.currentPage = 1;   // ✅ reset page
        this.fetchData();
      }

      // ✅ NEW: when search is cleared
      if (!this.filter || this.filter === "") {
        this.currentPage = 1;   // reset page
        this.fetchData();
      }
    },

    // ✅ MANUAL PAGE INPUT
    filterPage() {
      if (this.pageNo && this.pageNo > 0) {
        this.currentPage = Number(this.pageNo);
        this.fetchData();
      }
    },

    // ✅ URL SYNC (clean)
    updateUrl() {
      const url = new URL(window.location);

      if (this.filter) url.searchParams.set("search", this.filter);
      else url.searchParams.delete("search");

      url.searchParams.set("page", this.currentPage);
      url.searchParams.set("size", 20);
      url.searchParams.set("pagination", true);

      history.pushState({}, "", url);
    },

    // ✅ TRANSACTION
    async showTransaction(id) {
      const url = wow_doctor.getAiToolMemberTransactionHistory;

      const res = await this.getRequest(url + "/" + id);

      if (res.status) {
        this.transactionList = res.response.data;
        this.showTransactionModal = true;
      }
    },
    async saveTokens(id) {
        console.log('id', id);
        
      this.$store.commit("loader/updateStatus", true);

      try {
        let url = wow_doctor.wowDoctorAddTokenUrl;

        const payload = {
          doctorId: id,
          token: this.addTokens,
        };

        const data = await this.postRequest(url, payload);

        if (data.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });

          this.editedRowId = null;
          this.addTokens = 0;
          this.existingTokens = 0;

          this.fetchData();
        }

      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Please try again!",
        });
      }

      this.$store.commit("loader/updateStatus", false);
    },

    async saveCredits(id) {
        
      this.$store.commit("loader/updateStatus", true);

      try {
        let url = wow_doctor.wowDoctorAddCreditUrl;

        const payload = {
          doctorId: id,          
          amount: this.addCredits, 
        };

        const data = await this.postRequest(url, payload);

        if (data.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });

          this.editedCreditRowId = null;
          this.addCredits = 0;
          this.existingCredits = 0;

          this.fetchData();
        }

      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Please try again!",
        });
      }

      this.$store.commit("loader/updateStatus", false);
    },
  },

  watch: {
    currentPage(val) {
      if (val) this.fetchData();
    },
    filter(val) {
      if (!val) {
        this.currentPage = 1;
        this.fetchData();
      }
    }
  },

  created() {
    if (this.$route.query.search) {
      this.filter = this.$route.query.search;
    }

    if (this.$route.query.page) {
      this.currentPage = Number(this.$route.query.page);
    }

    this.fetchData();
  },
};